import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BmcLogo from '../../Images/dsmlogo2.png';
import SupportContent from './SupportContent';

const SupportPage = () => {
  const location = useLocation();
  const showBackToLogin = location.state?.source === 'login';

  return (
    <div className="support-public-page">
      <header className="support-public-header">
        <div className="support-public-header-inner">
          <div className="support-brand" aria-label="Tech Central">
            <img className="support-brand-mark" src={BmcLogo} alt="Tech Central" />
          </div>
          {showBackToLogin && (
            <Link className="support-back-login" to="/login">Back to Login</Link>
          )}
        </div>
      </header>

      <main className="support-main">
        <SupportContent />
      </main>
    </div>
  );
};

export default SupportPage;
